import React, { createContext, useContext, ReactNode } from 'react';
import { FeaturedJob } from 'rwl-shared/dist/models';

interface JobListContextProps {
    jobsList: FeaturedJob[];
}

const JobListContext = createContext<JobListContextProps | undefined>(
    undefined
);

interface JobListProviderProps {
    jobsList: FeaturedJob[];
    children: ReactNode;
}

/**
 * Useful for different components accessing different lists of jobs from the JobFetcher
 */
export const JobListProvider: React.FC<JobListProviderProps> = ({
    jobsList,
    children,
}) => {
    return (
        <JobListContext.Provider value={{ jobsList }}>
            {children}
        </JobListContext.Provider>
    );
};

export const useJobListContext = (): JobListContextProps => {
    const context = useContext(JobListContext);
    if (!context) {
        throw new Error(
            'useJobListContext must be used within a JobListProvider'
        );
    }
    return context;
};
